import { generateRadioButtonOptionsFromEnum } from 'components/final-form/radioUtils';
import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { AnyObject, FormApi } from 'final-form';
import { Button, Grid, Header, Popup, RadioProps } from 'semantic-ui-react';
import { BillPrintOption } from 'ts-types/api.enums';
import PxGrid from 'components/layout/PxGrid';
import FormButtonsRow from 'components/layout/FormButtonsRow';
import { Field } from 'react-final-form';
import CheckBox from 'components/final-form/CheckBox';
import Radio from 'components/final-form/Radio';

interface Props extends MessageSourceProps {
  handleSubmit: (values: AnyObject) => void,
  values: AnyObject,
  form: FormApi,
  disabled: boolean
}

interface State {
  printOptions: Array<RadioProps>,
  proofListPopup: boolean
}

class PrintProofListPopup extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const {getMessage} = props;

    const printOptions = generateRadioButtonOptionsFromEnum(
        Object.values(BillPrintOption), "billPrintOption", getMessage);

    this.state = {
      printOptions: printOptions,
      proofListPopup: false
    }

  }

  onOpenProoflistPopup = () => {

    const {form} = this.props;

    form.change("billPrintOption", BillPrintOption.BILL_PREVIEW);
    form.change("isDetailed", true);

    this.setState({
      proofListPopup: true
    });
  };

  onCloseProoflistPopup = () => {

    const {form} = this.props;

    form.change("billPrintOption", undefined);
    form.change("isDetailed", undefined);

    this.setState({
      proofListPopup: false
    });
  };

  onConfirmPrintProofList = () => {
    const {values, handleSubmit} = this.props;
    this.onCloseProoflistPopup();
    handleSubmit(values);
  }

  render(): React.ReactNode {
    const {proofListPopup} = this.state;
    const {disabled} = this.props;

    return (
        <Popup
            trigger={this.renderPrintProofListTrigger()}
            content={this.renderPrintProofListContent()}
            open={proofListPopup}
            onClose={() => !disabled && this.onCloseProoflistPopup()}
            onOpen={() => !disabled && this.onOpenProoflistPopup()}
            on='click'
            position={'top center'}
            hideOnScroll
        />

    );

  }

  renderPrintProofListTrigger = (): React.ReactNode => {

    const {disabled, getMessage} = this.props;

    return (
        <Button
            compact
            type="button"
            secondary
            disabled={disabled}
        >
          {getMessage("collectiveBill.printProoflist")}
        </Button>
    );
  };

  renderPrintProofListContent = (): React.ReactNode => {

    const {disabled, values, getMessage} = this.props;
    const {printOptions} = this.state;
    const detailDisabled = disabled || values.billPrintOption === BillPrintOption.BILL_PREVIEW;
    return (
        <PxGrid>
          <Grid.Row>
            <Grid.Column>
              <Header size="small">{getMessage("bill.printProoflist")}</Header>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Field
                  name="billPrintOption"
                  component={Radio}
                  radioDefinition={printOptions[0]}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Field
                  name="billPrintOption"
                  component={Radio}
                  radioDefinition={printOptions[1]}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Field
                  name="isExcel"
                  component={CheckBox}
                  label={getMessage("excelProofList")}
                  disabled={detailDisabled}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Field
                  name="isDetailed"
                  component={CheckBox}
                  label={getMessage("detailProofList")}
                  disabled={detailDisabled}
              />
            </Grid.Column>
          </Grid.Row>
          <FormButtonsRow>
            <Button compact primary
                    onClick={this.onConfirmPrintProofList}>{getMessage("button.ok")}</Button>
            <Button compact onClick={this.onCloseProoflistPopup}>{getMessage("button.close")}</Button>
          </FormButtonsRow>
        </PxGrid>
    );
  };
}

export default withMessages(PrintProofListPopup);
